import React, { useState } from 'react';
//import {makeStyles} from '@mui/material/styles';
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";



function RenderPriceTable(props) {

    const [displayArray, setDisplayArray] = useState(Array(4).fill('none'));
    const [displayMorePeriodTickets, setDisplayMorePeriodTickets] = useState(false);
    const [displayMoreReformPeriodTickets, setDisplayMoreReformPeriodTickets] = useState(false);
    const location = useLocation();
    const handleClick = index => e => {

        if (props.tripPrices.motNotYet && !index)
            return;
        let newArr = [...displayArray];
        let newStatus = newArr[index] === 'none' ? 'block' : 'none';
        newArr[index] = newStatus;

        setDisplayArray(newArr);
    }

    const { tripPrices } = props;
    let ravpassUrl = "https://ravpass.co.il";
    let ravkavUrl = "https://ravpass.co.il"
    const isAndroid = /(android)/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    let target = '_blank';
    if (location && location.search.includes("embed=ravpass")) {
        ravpassUrl = "https://prices.ravpass.co.il/openRavPass"
        ravkavUrl = "https://prices.ravpass.co.il/openRavKav"
        target = '_self'
    } else if (isAndroid) {
        ravpassUrl = "https://play.google.com/store/apps/details?id=co.hopon.client"
        ravkavUrl = "https://play.google.com/store/apps/details?id=com.mosko.ravkav"
        target = '_self'
    } else if (isIOS) {
        ravpassUrl = "https://apps.apple.com/il/app/id807807458"
        ravkavUrl = "https://apps.apple.com/il/app/id807807458"
        target = '_self'
    }

    if (!tripPrices || !tripPrices.legs)
        return null;

    let results = [];
    let hadPrices = false;
    let hadMotPrices = false;
    let hadMotReformPrices = false;

    let motPricesHeader = (<thead>
        <tr><th className="price-header" style={{ maxWidth: 90 }} rowSpan={2}><div >{'קו'}</div></th><th className="price-header" rowSpan={2}><div style={{ paddingLeft: 4, paddingRight: 4, whiteSpace: 'nowrap' }}>{'רדיוס'}</div></th><th colSpan={3}><div className="price-header" style={{ paddingLeft: 8, paddingRight: 8, whiteSpace: 'nowrap', textAlign: 'right' }}>{'מחיר לתיקוף לפי פרופיל'}</div></th></tr>
        <tr><th><div className="price-header">רגיל</div></th><th><div className="price-header" style={{ whiteSpace: 'nowrap', paddingLeft: 4, paddingRight: 4 }}>50%</div></th><th><div className="price-header" style={{ paddingLeft: 4, paddingRight: 4, whiteSpace: 'nowrap' }}>33%</div></th>
        </tr>

    </thead>)

    let motReformPricesHeader = (<thead>
        <tr><th className="price-header" style={{ maxWidth: 90 }} rowSpan={2}><div >{'קו'}</div></th><th className="price-header" rowSpan={2}><div style={{ paddingLeft: 4, paddingRight: 4, whiteSpace: 'nowrap' }}>{'רדיוס'}</div></th><th colSpan={3}><div className="price-header" style={{ paddingLeft: 8, paddingRight: 8, whiteSpace: 'nowrap', textAlign: 'right' }}>{'מחיר לתיקוף נסיעה בודדת לפי פרופיל'}</div></th></tr>
        <tr><th><div className="price-header">רגיל</div></th><th><div className="price-header" style={{ whiteSpace: 'nowrap', paddingLeft: 4, paddingRight: 4 }}>50%</div></th><th><div className="price-header" style={{ paddingLeft: 4, paddingRight: 4, whiteSpace: 'nowrap' }}>33%</div></th>
        </tr>

    </thead>)

    let motPricesRows = tripPrices.legs.map((leg, index) => {
        if (!leg.motPrice)
            return null;
        hadMotPrices = true;


        return (<tr className="prices-tr" key={"legPricesMot" + index}>
            <td style={{ padding: 8 }}><b>{leg.route}</b>{" " + (leg.price ? (leg.price.agency_name || "") : "")}</td>
            <td style={{ maxWidth: 20, padding: 8, whiteSpace: 'pre-wrap', textAlign: 'center' }}>{leg.motPrice.radiusKM ? ("עד " + leg.motPrice.radiusKM + " ק״מ") : "לא נתמך בשירות"}</td>
            <td style={{ padding: 8 }}>

                {isNaN(leg.motPrice.price) ? leg.motPrice.price : getPrice(leg.motPrice.price)
                    //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                }

            </td>
            <td style={{ padding: 8 }}>

                {isNaN(leg.motPrice.percent50) ? leg.motPrice.percent50 : getPrice(leg.motPrice.percent50)
                    //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                }

            </td>
            <td style={{ padding: 8 }}>

                {isNaN(leg.motPrice.percent33) ? leg.motPrice.percent33 : getPrice(leg.motPrice.percent33)
                    //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                }

            </td>

        </tr>)
    });




    let motReformPricesRows = tripPrices.legs.map((leg, index) => {
        if (!leg.motPrice)
            return null;
        hadMotReformPrices = true;


        return (<tr className="prices-tr" key={"legPricesMot" + index}>
            <td style={{ padding: 8 }}><b>{leg.route}</b>{" " + (leg.price ? (leg.price.agency_name || "") : "")}</td>
            <td style={{ maxWidth: 40, padding: 4, whiteSpace: 'pre-wrap', textAlign: 'center' }}><div style={{ fontWeight: '400', padding: 2, fontSize: 14, borderRadius: 6, backgroundColor: leg.motPrice.fareColor || 'transparent' }}>{(leg.motPrice.fareColorName ? (leg.motPrice.fareColorName + " ") : "") + (leg.motPrice.reformRadiusKM ? ("עד " + leg.motPrice.reformRadiusKM + " ק״מ") : "לא נתמך בשירות")}</div></td>
            <td style={{ padding: 8 }}>

                {isNaN(leg.motPrice.reformPrice) ? leg.motPrice.reformPrice : getPrice(leg.motPrice.reformPrice)
                    //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                }

            </td>
            <td style={{ padding: 8 }}>

                {isNaN(leg.motPrice.reformPercent50) ? leg.motPrice.reformPercent50 : getPrice(leg.motPrice.reformPercent50)
                    //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                }

            </td>
            <td style={{ padding: 8 }}>

                {isNaN(leg.motPrice.reformPercent33) ? leg.motPrice.reformPercent33 : getPrice(leg.motPrice.reformPercent33)
                    //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                }

            </td>

        </tr>)
    });

    if (hadMotPrices) {

        // reform totals
        motReformPricesRows.push(


            <tr className="prices-tr" key={"legPricesReformTotalSingle"}>
                <td colSpan={2} style={{ padding: 8 }}><b>סה״כ לנסיעה במסלול</b></td>

                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalReformPrice)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>

                </td>
                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalReformPrice50)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>
                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalReformPrice33)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>

            </tr>

        )


        motReformPricesRows.push(


            <tr className="prices-tr" key={"legPricesReformTotal2Rides"}>
                <td colSpan={2} style={{ padding: 8 }}><b>סה״כ לנסיעה הלוך ושוב</b></td>

                <td style={{ padding: 8 }}>
                    <b>
                        {


                            getPrice(tripPrices.totalReformPrice * 2)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>

                </td>
                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalReformPrice50 * 2)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>
                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalReformPrice33 * 2)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>

            </tr>

        )



        // before reform



        motPricesRows.push(


            <tr className="prices-tr" key={"legPricesMotTotalSingle"}>
                <td colSpan={2} style={{ padding: 8 }}><b>סה״כ לנסיעה במסלול</b></td>

                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalMotPrice)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>

                </td>
                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalMotPrice50)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>
                <td style={{ padding: 8 }}>
                    <b>
                        {getPrice(tripPrices.totalMotPrice33)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>

            </tr>

        )

        motPricesRows.push(


            <tr className="prices-tr" key={"legPricesMotTotal2Rides"}>
                <td colSpan={2} style={{ padding: 8 }}><b>סה״כ לנסיעה הלוך ושוב</b></td>

                <td style={{ padding: 8 }}>
                    {tripPrices.totalMot2RidesBeforeDiscount && (<span className="strikethrough">{getPrice(tripPrices.totalMot2RidesBeforeDiscount)}<br /></span>)}
                    <b>
                        {


                            getPrice(tripPrices.totalMot2Rides)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>

                </td>
                <td style={{ padding: 8 }}>
                    {tripPrices.totalMot2Rides50BeforeDiscount && (<span className="strikethrough">{getPrice(tripPrices.totalMot2Rides50BeforeDiscount)}<br /></span>)}
                    <b>
                        {getPrice(tripPrices.totalMot2Rides50)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>
                <td style={{ padding: 8 }}>
                    {tripPrices.totalMot2Rides33BeforeDiscount && (<span className="strikethrough">{getPrice(tripPrices.totalMot2Rides33BeforeDiscount)}<br /></span>)}
                    <b>
                        {getPrice(tripPrices.totalMot2Rides33)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>

            </tr>

        )

        motPricesRows.push(


            <tr className="prices-tr" key={"legPricesMotTotalMonthly"}>
                <td colSpan={2} style={{ padding: 8 }}><b>סה״כ לנסיעות הלוך ושוב בימי חול במשך חודש*</b></td>

                <td style={{ padding: 8 }}>
                    {tripPrices.totalMotMonthlyBeforeDiscount && (<span className="strikethrough">{getPrice(tripPrices.totalMotMonthlyBeforeDiscount)}<br /></span>)}
                    <b>
                        {getPrice(tripPrices.totalMotMonthly)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>

                </td>
                <td style={{ padding: 8 }}>
                    {tripPrices.totalMotMonthly50BeforeDiscount && (<span className="strikethrough">{getPrice(tripPrices.totalMotMonthly50BeforeDiscount)}<br /></span>)}
                    <b>
                        {getPrice(tripPrices.totalMotMonthly50)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>
                <td style={{ padding: 8 }}>
                    {tripPrices.totalMotMonthly33BeforeDiscount && (<span className="strikethrough">{getPrice(tripPrices.totalMotMonthly33BeforeDiscount)}<br /></span>)}
                    <b>
                        {getPrice(tripPrices.totalMotMonthly33)
                            //  (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : getPrice(transferPrice ? transferPrice.price : leg.price.price)
                        }
                    </b>
                </td>

            </tr>

        )


        let compareText = "לצורך השוואה למנוי חודשי הובאו בחשבון כ-" + tripPrices.workingDays + " ימי חול, ייתכן והמחיר החודשי יהיה גבוה או נמוך יותר בהתאם למספר הנסיעות בפועל. "
        //    results.push(<div key="MotTitle" className="h5" style={{ marginTop: 32, marginBottom: 16 }}><b>בקרוב! אפליקציית <a style={{ textDecoration: 'none',color:'#00B5E5' }} href={"https://hopon.co.il"} target={'blank'}>רב-פס</a> לתיקוף מהנייד ותשלום בסוף החודש, אלה המחירים:</b></div>)

        /*  results.push(<div key="MotTitle" className="collapsible" ><div style={{flexDirection:'row'}}><span onClick={handleClick(0)}><b> תשלום מהנייד ב</b></span><span><a style={{ textDecoration: 'none',color:'#22a7f0' }} href={ravpassUrl} target={target}><b>אפליקציית רב-פס</b></a></span>
                  {renderBestFor('MOT',tripPrices)}
      
              </div>{!tripPrices.motNotYet && (<div style={{display:'flex',minHeight:40,minWidth:40,justifyContent:'center',alignItems:'center',alignContent:'center',alignSelf:'center'}} onClick={handleClick(0)}><i  id="chevron" className={"fa fa-chevron-" + (displayArray[0] === 'none' ? "down" : "up")}  /></div>)}</div>) */

        let trainText = "ברכבת ישראל - מחירי הנסיעה הבודדת בתשלום מהנייד מבוססים על תעריפי הרכבת (בהתאם לתחנת המוצא ותחנת היעד). מרחק הנסיעה משפיע רק על המחיר היומי המקסימלי.";
        let motPricesTable = (<div className='content' style={{ overflowX: 'scroll', display: displayArray[0] }} key={"motPricesTable"}><table className="prices-table">{motPricesHeader}<tbody>{motPricesRows}</tbody></table>
            <div key="maxPriceDaily" style={{ fontSize: 12, margin: 16 }}>מחיר יומי מקסימלי לכל הנסיעות ברדיוס של המסלול שנבחר: {getPrice(tripPrices.maxMotDaily)}<br />
                אזרחים ותיקים ונוער עד גיל 18 זכאים ל 50% הנחה ממחיר נסיעה בודדת.
                סטודנטים/זכאי ביטוח לאומי/נכים זכאים ל 33% הנחה ממחיר נסיעה בודדת.
                בנסיעה אל ובתוך אילת מנוכה מע״מ ממחירי הנסיעה הבודדת. {tripPrices.haveTrain ? (<span>{trainText}</span>) : null}<br />

                <br />* לצורך חישוב הנחה חודשית, החלה על סך שימושים מעל ₪200, יובאו בחשבון תיקופים ביישומון רב-פס שבוצעו בין ה25 לחודש בשעה חצות ועד לסוף היום ה-24 בחודש העוקב.

                <br />{compareText}
                <a href='https://s3-eu-west-1.amazonaws.com/static.hopon.co.il/mot/ravPassPrices.html' target="_blank" rel="noreferrer">פרטים נוספים על השירות</a>

            </div>

        </div>)
        //  results.push(motPricesTable);



        //<div key="maxMontlyPrice">{"רף שימושים חודשי המזכה בהנחה נוספת: " + getPrice(200)}</div>
        //results.push()
        //results.push()
        //   if(trip.trip.haveTrain){

        // }


    }




    let pricesHeader = (<thead>
        <tr><th className="price-header" style={{ maxWidth: 90 }} rowSpan={2}><div>{'קו'}</div></th><th className="price-header" rowSpan={2}><div style={{ paddingLeft: 4, paddingRight: 4 }}>{'ערך צבור*'}</div></th><th colSpan="3"><div className="price-header" style={{ paddingLeft: 8, paddingRight: 8, whiteSpace: 'nowrap', textAlign: 'right' }}>{'מחיר בפועל לאחר הנחת פרופיל'}</div></th>
        </tr>
        <tr><th><div className="price-header">20% רגיל</div></th><th><div className="price-header" style={{ whiteSpace: 'nowrap', paddingLeft: 4, paddingRight: 4 }}>50%</div></th><th><div className="price-header" style={{ paddingLeft: 4, paddingRight: 4, whiteSpace: 'nowrap' }}>33%</div></th>
        </tr></thead>)

    let transferPrice = tripPrices.transferPrice;


    //  let hadFreeOnElections = false;
    let pricesRows = tripPrices.legs.map((leg, index) => {
        if (!leg.price && !transferPrice)
            return null;
        hadPrices = true;
        let basePrice = (transferPrice && index > 0 && !leg.price.isFree) ? " מעבר " : (leg.price && leg.price.priceLabel) ? leg.price.priceLabel : transferPrice ? transferPrice.price : leg.price.price;
        let code = "";
        // if(transferPrice && !index && transferPrice.code){
        if (leg.price.code) {
            code = " קוד " + leg.price.code;
        }
        // }
        //    if(leg.isFreeOnElections)
        //    hadFreeOnElections = true;
        //<td style={{ padding: 8, whiteSpace: 'pre-wrap' }}>{leg.price.isFree ? "" : (((transferPrice && index > 0) ? "רב-קו" : this.getPriceLabel(transferPrice || leg.price)) + (leg.isFreeOnElections ? "\nחינם ביום הבחירות*" : ""))}</td>
        // <td style={{ padding: 8, whiteSpace: 'pre-wrap' }}>{leg.price.isFree ? "" : (((transferPrice && index > 0) ? "רב-קו" : this.getPriceLabel(transferPrice || leg.price)) )}</td>
        // <a style={{ textDecoration: 'none',color:'#482E93' }} href={"https://hopon.co.il?predefined=200"}>
        //{isNaN(basePrice) ? basePrice : (getPrice(basePrice) + code)}
        //</a>
        return (<tr className="prices-tr" key={"legPrices" + index}>
            <td style={{ padding: 8 }}><b>{leg.route}</b>{" " + (leg.price ? (leg.price.agency_name || "") : "")}</td>
            <td style={{ padding: 8 }}>
                {isNaN(basePrice) ? basePrice : (getPrice(basePrice) + code)}
            </td>
            <td style={{ padding: 8 }}>
                {isNaN(basePrice) ? basePrice : getPrice(leg.price.percent25)}
            </td>
            <td style={{ padding: 8 }}>
                {isNaN(basePrice) ? basePrice : getPrice(leg.price.percent50)}
            </td>
            <td style={{ padding: 8 }}>
                {isNaN(basePrice) ? basePrice : getPrice(leg.price.percent33)}
            </td>

        </tr>)
    }
    )

    pricesRows.push(<tr className="prices-tr" key={"totalRegularCreditValue"}>
        <td style={{ padding: 8 }} colSpan={2}><b>סה״כ לנסיעה במסלול שנבחר</b></td>

        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValue25)}
        </td>
        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValue50)}
        </td>
        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValue33)}
        </td>

    </tr>)

    pricesRows.push(<tr className="prices-tr" key={"total2ridesCreditValue"}>
        <td style={{ padding: 8 }} colSpan={2}><b>סה״כ לנסיעה הלוך ושוב</b></td>

        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValue25For2Rides)}
        </td>
        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValue50For2Rides)}
        </td>
        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValue33For2Rides)}
        </td>

    </tr>)

    pricesRows.push(<tr className="prices-tr" key={"totalMonthhlyCreditValue"}>
        <td style={{ padding: 8 }} colSpan={2}><b>סה״כ לנסיעות הלוך ושוב בימי חול במשך חודש**</b></td>

        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValueMonthly)}
        </td>
        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValueMonthly50)}
        </td>
        <td style={{ padding: 8 }}>
            {getPrice(tripPrices.totalCreditValueMonthly33)}
        </td>

    </tr>)

    let compareText = "**לצורך השוואה למנוי חודשי הובאו בחשבון כ-" + tripPrices.workingDays + " ימי חול, ייתכן והמחיר החודשי יהיה גבוה או נמוך יותר בהתאם למספר הנסיעות בפועל."
    let pricesTable = (<div className='content' style={{ overflowX: 'scroll', display: displayArray[1] }} key={"pricesTable"}><table className="prices-table">{pricesHeader}<tbody>{pricesRows}</tbody></table>
        <div key="ravvkavdiscounts" style={{ fontSize: 12, margin: 16 }}><br />* מחיר רגיל נקוב לנסיעה בודדת. טעינת ערך צבור ותיקוף הנסיעה באמצעות רב-קו יתן לך הנחה מהמחיר הנקוב לפי סוג הפרופיל שטעון על הכרטיס:
            <ul style={{ paddingInlineStart: 16 }}>
                <li>הנחה רגילה לכולם: 20%</li>
                <li>הנחה לפרופיל סטודנט וזכאי ביטוח לאומי: 33%</li>
                <li>הנחה לפרופיל נוער, אזרח ותיק וסטודנט מורחב: 50%</li>
            </ul>
            {compareText}
        </div>
    </div>)
    /*   if (hadPrices){
           results.push(<div key="CreditValueTitle" className="collapsible"><div style={{flexDirection:'row'}}><span onClick={handleClick(1)}><b>תיקוף ערך צבור ב</b></span><span><b><a style={{ textDecoration: 'none',color:'#22a7f0' }} href={ravkavUrl} target={target}>רב-קו</a></b></span>
   
               {renderBestFor('creditValue',tripPrices)}
   
           </div><div style={{display:'flex',minHeight:40,minWidth:40,justifyContent:'center',alignItems:'center',alignContent:'center',alignSelf:'center'}} onClick={handleClick(1)}><i id="chevron" className={"fa fa-chevron-" + (displayArray[1] === 'none' ? "down" : "up")} /></div></div>)
           results.push(pricesTable);
       }*/

    //  if(hadFreeOnElections)
    //    results.push(<div key="electionsFree" style={{marginTop:4,marginBottom:0,color:'gray'}}>*החל מיום א' 1/3/2020 בשעה 20:00 ועד יום ב' 2/3/2020 בשעה 23:59. <a style={{ textDecoration: 'underline' }} href='https://bechirot23.bechirot.gov.il/election/Documents/דובר%20ועדת%20הבחירות/כנסת%2023/Free_Public_Transport_Election_Day.pdf'>פרטים נוספים כאן</a></div>)
    let periodTickets = tripPrices.periodTickets && tripPrices.periodTickets.map((element, index) => {

        return (
            <tr className="prices-tr" key={"ticket" + index} style={{ display: ((!index || displayMorePeriodTickets) ? null : 'none') }}>
                <td style={{ borderWidth: 1, padding: 8, maxWidth: 80 }}>
                    <b>{element.ShareCode}</b>{' ' + element.ShareCodeDesc}
                </td>
                <td className={element.Daily ? "currency-td" : "notsold-td"}>

                    {getPrice(element.Daily)}

                </td>
                <td className={element.Weekly ? "currency-td" : "notsold-td"}>

                    {getPrice(element.Weekly)}

                </td>
                <td className={element.Monthly ? "currency-td" : "notsold-td"}>

                    {getPrice(element.Monthly)}

                </td>
                <td className={element.DailySenior ? "currency-td" : "notsold-td"}>

                    {getPrice(element.DailySenior)}

                </td>
                <td className={element.WeeklySenior ? "currency-td" : "notsold-td"}>

                    {getPrice(element.WeeklySenior)}

                </td>
                <td className={element.MonthlySenior ? "currency-td" : "notsold-td"}>

                    {getPrice(element.MonthlySenior)}

                </td>
            </tr>

        )
    });


    let hadReformDaily = false;
    let hadReformMonthly = false;
    let additionalReformTickets = 0;
    let reformPeriodTickets = tripPrices.reformPeriodTickets && tripPrices.reformPeriodTickets.map((element, index) => {

        let display = null;
        if (element.ett == 22) {
            if (!displayMoreReformPeriodTickets && hadReformDaily) {
                display = 'none';
                additionalReformTickets++;
            }
            hadReformDaily = true;
        } else if (element.ett == 20) {
            if (!displayMoreReformPeriodTickets && hadReformMonthly) {
                display = 'none';
                additionalReformTickets++;
            }
            hadReformMonthly = true;
        }

        let contractType = (element.ett == 22) ? "יומי " : "חודשי ";
        if (element.ett == 20 && element.transportion.includes(";Train")) {
            contractType += "ארצי ";
        }
        let contractTitle = element.colorname + " " + (element.transportion.includes(";Train") ? "כולל רכבת ישראל " : "") + element.farecodedesc;
        return (
            <tr className="prices-tr" key={"ticket" + index} style={{ display }}>
                <td style={{ borderWidth: 1, padding: 8, maxWidth: 40, minWidth: 40 }}>
                    <b>{element.predefinedcode}</b>
                </td>

                <td style={{ borderWidth: 1, maxWidth: 140 }}>
                    <div style={{ fontWeight: '400', padding: 8, fontSize: 14, borderRadius: 6, backgroundColor: element.colorcode || 'transparent' }}>
                        <b>{contractType}</b>{contractTitle}
                    </div>
                </td>

                <td className={"currency-td"}>

                    {getPrice(element.price)}

                </td>
                {/*<td className={"currency-td"}>

                    {getPrice(element.price / 2)}

                </td>
                <td className={element.ett == 20 ? "currency-td" : "notsold-td"}>

                    {element.ett == 20 ? getPrice(element.price / 2) : "לא נמכר"}

                </td>*/}

            </tr>

        )
    });

    if (additionalReformTickets > 0 && !displayMoreReformPeriodTickets) {
        reformPeriodTickets.push(<tr key='morePeriods'><td colSpan={7}><div style={{ fontSize: 12, marginTop: 12, textDecoration: 'underline', color: 'blue' }} onClick={() => setDisplayMoreReformPeriodTickets(true)}
        >{'ישנם ' + (additionalReformTickets) + ' מנויים נוספים המאפשרים נסיעה ללא הגבלה במסלול שנבחר'}</div></td></tr>)
    }


    if (periodTickets && periodTickets.length) {

        if (periodTickets.length > 1) {
            let cheapest = (<tr key='cheapestPeriod'><td colSpan={7}><div style={{ fontSize: 12, marginTop: 12 }}>המנוי הזול ביותר לנסיעה ללא הגבלה במסלול שנבחר:</div></td></tr>)
            periodTickets.splice(0, 0, cheapest)
            cheapest = (<tr key='morePeriods'><td colSpan={7}><div style={{ fontSize: 12, marginTop: 12, textDecoration: 'underline', color: 'blue' }} onClick={() => setDisplayMorePeriodTickets(true)}
            >{'ישנם ' + (periodTickets.length - 2) + ' מנויים נוספים המאפשרים נסיעה ללא הגבלה במסלול שנבחר'}</div></td></tr>)
            periodTickets.splice(2, 0, cheapest)
        }

        /*  results.push(<div key="periodTitle" className="collapsible"><div style={{flexDirection:'row'}}><span onClick={handleClick(2)}><b>מנוי חופשי תקופתי לטעינה ב</b></span><span><b><a style={{ textDecoration: 'none',color:'#22a7f0' }} target={target} href={ravkavUrl}>רב-קו</a></b></span>
  
              {renderBestFor('periodTicket',tripPrices)}
  
          </div><div style={{display:'flex',minHeight:40,minWidth:40,justifyContent:'center',alignItems:'center',alignContent:'center',alignSelf:'center'}} onClick={handleClick(2)}><i id="chevron" className={"fa fa-chevron-" + (displayArray[2] === 'none' ? "down" : "up")} /></div></div>)*/

        let tableHeader = (
            <thead>
                <tr><th className="price-header" style={{ maxWidth: 80 }} rowSpan={2}><div>{'קוד ושם המנוי'}</div></th><th style={{ maxWidth: 80 }} colSpan={6}><div className="price-header" style={{ textAlign: 'right', paddingRight: 8 }} >{'מחיר לפי סוג המנוי'}</div></th></tr>
                <tr><th><div className="price-header">{'יומי'}</div></th><th><div className="price-header">{'שבועי'}</div></th><th><div className="price-header">{'חודשי'}</div></th><th><div className="price-header" style={{ whiteSpace: 'nowrap' }}>{'יומי ותיק'}</div></th><th><div className="price-header" style={{ whiteSpace: 'nowrap' }}>{'שבועי ותיק'}</div></th><th><div className="price-header" style={{ whiteSpace: 'nowrap' }}>{'חודשי ותיק'}</div></th>
                </tr>
            </thead>)


        /*      if (periodTickets) {
                   let periodTable = (<div className='content' style={{overflowX:'scroll',display: displayArray[2]}}  key={"periodTable"}><table className="prices-table">{tableHeader}<tbody>{periodTickets}</tbody></table></div>)
                   results.push(periodTable)
       
       
       
       
               } else {
                   results.push(<div key="noravkav">אין מידע. תוכל לברר פרטים בטלפון *8787</div>)
               }*/

    }


    // 2022 Reform

    if (hadMotPrices) {
       // results.push(<a key="MotReformTitle_url" style={{ textDecoration: 'none' }} target='_blank' href={"https://ravpass.co.il"}><div key="MotReformTitle" className="collapsible" ><div style={{ flexDirection: 'row' }}><span><b>מחירים חדשים ברפורמת דרך שווה החל מאוגוסט</b></span>
        //    {renderBestFor('MOTReform', tripPrices)}

        //</div>{!tripPrices.motNotYet && (<div style={{ display: 'flex', minHeight: 40, minWidth: 40, justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}></div>)}</div></a>)

        let motPricesTable = (<div className='content' style={{ overflowX: 'scroll', display: 'block' }} key={"motReformPricesTable"}><table className="prices-table">{motReformPricesHeader}<tbody>{motReformPricesRows}</tbody></table>




        </div>)



        results.push(motPricesTable);

    }

    if (reformPeriodTickets) {


        let tableHeader = (
            <thead>
                <tr>
                    <th className="price-header" style={{ maxWidth: 40, minWidth: 40 }} colSpan={3}><div>{'מנויים לנסיעה חופשית במסלול שנבחר *'}</div></th>
                </tr>
                <tr>
                    <th className="price-header" style={{ maxWidth: 40, minWidth: 40 }} rowSpan={1}><div>{'קוד'}</div></th><th className="price-header" style={{ maxWidth: 180 }} rowSpan={1}><div>{'סוג מנוי'}</div></th><th style={{ maxWidth: 80 }} colSpan={1}><div className="price-header" style={{ textAlign: 'right', paddingRight: 8 }} >{'מחיר רגיל'}</div></th></tr>

            </thead>)
        let periodTable = (<div className='content' style={{ overflowX: 'scroll', display: 'block' }} key={"reformPeriodTable"}><table className="prices-table">{tableHeader}<tbody>{reformPeriodTickets}</tbody></table></div>)
        results.push(periodTable)

    }

    if (!periodTickets && !hadPrices) {
        results.push(<div key="noravkav">אין לנו מידע על התעריפים במסלול הנבחר :(</div>)
    } else {

        results.push(<div key="reformPriceRemark" style={{ display: 'block', fontSize: 12, margin: 16 }}>
             *ברב-קו יש לטעון מנוי מתאים או ערך צבור לפני הנסיעה. בתיקוף מהנייד עם רב-פס נוסעים ללא התחייבות ותשלום מראש והאפליקציה מחשבת אוטומטית בסוף התקופה (החלה בין ה25 לחודש ל-24 בחודש העוקב) את מחיר הנסיעה הזול ביותר עד לתקרת המנוי היומי ו/או החודשי המתאים.<br />
                ברישום מוקדם ולאחר אישור פרופיל הזכאות, נשים מגיל 62 עד 67 זכאיות ל- 50% הנחה ממחיר נסיעה בודדת, חופשי יומי וחופשי חודשי. אזרחים ותיקים מעל לגיל 67 זכאים לנסיעות ללא עלות.
                 נוער עד גיל 18, זכאי ביטוח לאומי ונכים זכאים ל- 50% הנחה ממחיר נסיעה בודדת וממחיר חופשי חודשי.
                 צעירים מגיל 18 ועד גיל 26 זכאים ל- 33% אחוז הנחה ממחיר חופשי חודשי.
                  סטודנטים זכאים ל- 33% הנחה ממחיר נסיעה בודדת. 
                  תושבי אזורים ושכונות בדירוג חברתי-כלכלי 1 עד 5 זכאים ל- 50% הנחה ממחיר חופשי חודשי.
                  חיילים משוחררים/בוגרי שרות לאומי זכאים לנסיעות ללא עלות עד שנה מיום השחרור. 
                  עיוורים וחברי כנסת זכאים לנסיעות ללא עלות.
                בנסיעה אל אילת, בתוך אילת ומתוך אילת מחירי נסיעה בודדת ללא מע״מ.<br />

            <a href='https://s3-eu-west-1.amazonaws.com/static.hopon.co.il/mot/ravPassPrices.html' target="_blank" rel="noreferrer">פרטים נוספים על השירות</a>

        </div>)


    }



    return (
        results
    );
}


function renderBestFor(type, trip) {
    let result = [];



    if (type === 'MOT' && trip.motNotYet) {
        result.push(
            <div key={'bestDialyFor' + type} style={{ fontSize: 14, color: 'red' }}>
                <i className="fa fa-times-circle" ></i> בשלב זה התשלום במזרח ירושלים/מוניות שירות ברב-קו בלבד</div>
        )
        return result;
    }

    if (type === 'MOTReform') {
        result.push(
            <div key={'motReform1' + type} style={{ fontSize: 14, color: 'green' }}>
                <i className="fa fa-check-circle" ></i> מחירים זהים בין רב-קו לרב-פס</div>
        )

        result.push(
            <div key={'motReform2' + type} style={{ fontSize: 14, color: 'green' }}>
                <i className="fa fa-check-circle" ></i> רק ברב-פס תשלמו את המחיר המשתלם ביותר ללא התחייבות מראש*</div>
        )
        return result;
    }

    if (trip.bestForSingleRide === type) {
        result.push(
            <div key={'bestDialyFor' + type} style={{ fontSize: 14, color: 'green' }}>
                <i className="fa fa-check-circle" ></i> הכי משתלם לנסיעה בודדת</div>
        )
    }

    if (trip.bestForTwoRides === type) {
        let text = "הכי משתלם לנסיעה הלוך ושוב"
        if (type === 'periodTicket')
            text += " (חופשי יומי)"
        result.push(
            <div key={'best2RidesFor' + type} style={{ fontSize: 14, color: 'green' }}>
                <i className="fa fa-check-circle" ></i> {text}</div>
        )
    }

    if (trip.bestForMonthly === type) {
        result.push(
            <div key={'bestMonthly' + type} style={{ fontSize: 14, color: 'green' }}>
                <i className="fa fa-check-circle" ></i> הכי משתלם לנסיעות הלוך ושוב בימי חול במשך חודש</div>
        )
    }

    if (type === 'MOT') {

        result.push(
            <div key={'bestPostPay' + type} style={{ fontSize: 14, color: 'green' }}>
                <i className="fa fa-check-circle" ></i> משלמים אחת לחודש רטרואקטיבית. לא נסעת לא שילמת!</div>
        )
    }



    return result;


}


/*function getPriceLabel(price) {


    if (price.priceLabel) {
        return "";
    }
    if (price.code) {
        let result = "קוד " + price.code
        if (price.transfers) {
            result += " ברב-קו בלבד כולל מעברים ללא תשלום";
        }
        return result;
    }


    if (null == price.payment_method)
        return "";

    if (price.agency_id == 2) {
        // return "מזומן/אשראי/ערך צבור בקופות/מכונות כרטיסים"
        // corona
        return "אשראי/ערך צבור בקופות/מכונות כרטיסים"
    }

    if (0 == price.payment_method) {
        if (price.agency_id === 98)
            return "במזומן, אשראי ורב-קו (בימי חול)"
        else if (price.agency_id === 30)
            return "ברב-קו ובמזומן ברציף"
        else if (price.agency_id === 21)
            return "ערך צבור ברב-קו או רכישת כרטיס בודד ברציף"
        // return "במזומן וברב-קו"
        // corona:
        return "ברב-קו בלבד";

    } else {
        return "ברב-קו בלבד";
    }
}*/

function getPrice(price) {



    if (!price) {
        return "לא נמכר";
    }

    if (Number.isInteger(price)) {
        return parseInt(price) + '\u200F₪';
    }
    if (typeof price === 'string' || price instanceof String) {
        return price + '\u200F₪';
    }

    return price.toFixed(2) + '\u200F₪';
}

const mapStateToProps = (state, ownProps) => {

    return {

    }
}

const mapDispatchToProps = (dispatch, ownProps) => {

    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RenderPriceTable)